module.exports = __webpack_public_path__ + "static/media/bull.af49ce38.svg";